import type { ParsedUrlQuery } from 'querystring';

import keys from 'lodash/keys';
import map from 'lodash/map';
import reduce from 'lodash/reduce';

import { getSiteUrl } from './constants';

export const BASE_PATH = '/signup';

// Query params
export const PARTNER_API_USER_TOKEN = 'utoken';
export const MESSENGER_BASED_SIGNUP = 'messenger';
export const PARTNER_API_PARTNER_RAW_DATA_TOKEN = 'ptoken';

export const APP_URL = `${getSiteUrl()}/app`;
export const ANDROID_URL = `https://play.google.com/store/apps/details?id=com.jerrym`;
export const IOS_URL = `https://itunes.apple.com/us/app/jerry-your-insurance-shopper/id1258315950`;
export const JERRY_PHONE_URL = 'tel:18334453779';
export const IOS_URL_CAR_VALUE =
  'https://apps.apple.com/us/app/jerry-the-allcar-app/id1258315950?ppid=78b57847-efb9-4803-892d-12703bf47c05';
export const ANDROID_URL_CAR_VALUE = 'https://play.google.com/store/apps/details?id=com.jerrym';

/**
 * Extracts pathname from URL and returns patname and query string seperately.
 *
 * @param url
 */
export const getPathnameFromURL = (url: string): [string, string] => {
  const match = url.match(/[?#]/);
  return match ? [url.substr(0, match.index), url.substr(match.index || 0)] : [url, ''];
};

/**
 * Converts a query object into a string
 */
export const makeQueryStr = (query: ParsedUrlQuery): string => {
  const queryStr = map(keys(query), (arg) => `${arg}=${query[arg]}`).join('&');
  return queryStr === '' ? queryStr : `?${queryStr}`;
};

/**
 * Converts a query string to into an object.
 *
 * @param queryStr - Format: '?param1=val1&param2=val2'
 */
export const makeQueryObj = (queryStr: string): Record<string, string> => {
  // Must begin with '?'
  if (!queryStr.match(/^\?/)) return {};

  return reduce(
    queryStr.substr(1).split('&'),
    (memo, param) => {
      const [k, v] = param.split('=', 2);
      return {
        ...memo,
        [decodeURIComponent(k)]: decodeURIComponent(v),
      };
    },
    {} as Record<string, string>
  );
};
